!function(factory){"use strict";"function"==typeof define&&define.amd?define(["jquery"],factory):jQuery&&!jQuery.fn.hoverIntent&&factory(jQuery)}(function($){"use strict";var cX,cY,_cfg={interval:100,sensitivity:6,timeout:0},INSTANCE_COUNT=0,track=function(ev){cX=ev.pageX,cY=ev.pageY},compare=function(ev,$el,s,cfg){if(Math.sqrt((s.pX-cX)*(s.pX-cX)+(s.pY-cY)*(s.pY-cY))<cfg.sensitivity)return $el.off(s.event,track),delete s.timeoutId,s.isActive=!0,ev.pageX=cX,ev.pageY=cY,delete s.pX,delete s.pY,cfg.over.apply($el[0],[ev]);s.pX=cX,s.pY=cY,s.timeoutId=setTimeout(function(){compare(ev,$el,s,cfg)},cfg.interval)},delay=function(ev,$el,s,out){return delete $el.data("hoverIntent")[s.id],out.apply($el[0],[ev])};$.fn.hoverIntent=function(handlerIn,handlerOut,selector){var instanceId=INSTANCE_COUNT++,cfg=$.extend({},_cfg);$.isPlainObject(handlerIn)?(cfg=$.extend(cfg,handlerIn),$.isFunction(cfg.out)||(cfg.out=cfg.over)):cfg=$.isFunction(handlerOut)?$.extend(cfg,{over:handlerIn,out:handlerOut,selector:selector}):$.extend(cfg,{over:handlerIn,out:handlerIn,selector:handlerOut});var handleHover=function(e){var ev=$.extend({},e),$el=$(this),hoverIntentData=$el.data("hoverIntent");hoverIntentData||$el.data("hoverIntent",hoverIntentData={});var state=hoverIntentData[instanceId];state||(hoverIntentData[instanceId]=state={id:instanceId}),state.timeoutId&&(state.timeoutId=clearTimeout(state.timeoutId));var mousemove=state.event="mousemove.hoverIntent.hoverIntent"+instanceId;if("mouseenter"===e.type){if(state.isActive)return;state.pX=ev.pageX,state.pY=ev.pageY,$el.off(mousemove,track).on(mousemove,track),state.timeoutId=setTimeout(function(){compare(ev,$el,state,cfg)},cfg.interval)}else{if(!state.isActive)return;$el.off(mousemove,track),state.timeoutId=setTimeout(function(){delay(ev,$el,state,cfg.out)},cfg.timeout)}};return this.on({"mouseenter.hoverIntent":handleHover,"mouseleave.hoverIntent":handleHover},cfg.selector)}});

// initializing 
(function() {
  $(document).ready(function() {
    SwellConfig.Faq.initializeFaqs(".swell-question-button, .swell-question-list");
    SwellConfig.Link.initializeLinks(".swell-link-login, .swell-link-register");
    SwellConfig.LocalStorage.initializeLocalStorage();

    $(".swell-post-checkout").css("display", "flex");
    $( 'body' ).on('click',".swell-post-checkout-beach .swell-post-checkout-holder .swell-post-checkout-image .swell-referral-back-link", function() {
      $(".swell-post-checkout-beach").hide();
    });
  });

  $(document).on("swell:setup", function() {
    Swell.Campaign.initializeCampaigns(".swell-campaign-list", SwellConfig.Campaign.opts);
    SwellConfig.Campaign.authenticate();
    SwellConfig.Referral.initializeReferral(".swell-referral");
    SwellConfig.Customer.initializeHistory(".swell-history-link");
    SwellConfig.Tier.initializeCustomTierProperties();
    SwellConfig.Tier.initializeTiers(".swell-tier-table");
    Swell.Redemption.initializeCouponRedemptions(".swell-redemption-option-list", SwellConfig.Redemption.opts);
    // Swell.Redemption.initializeProductRedemptions(".swell-redemption-product-list", SwellConfig.Redemption.opts);

    $(".swell-campaign-list .swell-campaign:nth-child(8)").after('<li class="swell-campaign brancd-logo"> <div class="swell-campaign-content" data-display-mode="modal" data-campaign-id="<%= campaign.id %>"> <div class="swell-campaign-icon"> <i class="swell-campaign-icon-content swell-icon-BB-Logo"></i></div> </div> </div> </li>');

    var redemptionOptions = spapi.activeRedemptionOptions;
    var triangle = 0, l_skimpy = 0, stephani = 0, rib = 0, ri_skimpy =0, ri_tide = 0, peyton = 0, niko = 0, ri_knot = 0, haydenb = 0, haydens = 0, haydenh = 0  

    redemptionOptions.forEach(function(option) {
      if(option.discount_type == "product") {

        if(option.icon.indexOf("triangle") >= 0) {
          option_name = option.icon.split("-")[1]
          if(triangle == 0) {
            $(".swell-redemption-product-list").append('<li class="swell-redemption-product"> <div class="swell-redemption-product-content" data-redemption-option-id="' + option.id + '"> <div class="swell-redemption-product-image"> <img src="' + option.background_image_url + '" class="swell-product-image"> </div> <div class="swell-redemption-product-value">' + option.name + '</div> <div class="swell-redemption-product-cost">' + option.cost_text + '</div> <div class="variant-dropdown triangle-dropdown"> </div>  <div class="triangle-redeem">    <div class="swell-redemption-product-btn swell-buy-product-btn swell-buy-main-btn" data-variant-id="'+ option.applies_to_id + '">Redeem Now</div>  </div>  </div> </li>');
            $(".variant-dropdown.triangle-dropdown").append('<select class="product-dropdown triangle-select redemption-sizes" id="triangle-select"> <option value="' + option.id +'">' + option_name +' </option> </select> ');
            triangle += 1;
          } else {
            $(".triangle-redeem").append('<div class="swell-redemption-product-btn swell-buy-product-btn" data-variant-id="' + option.applies_to_id +'">Redeem Now</div>');
            $(".triangle-select").append('<option value="' + option.id +'">' + option_name +'</option>');
          }
        }

        else if(option.icon.indexOf("l_skimpy") >= 0) {
          option_name = option.icon.split("-")[1]
          if(l_skimpy == 0) {
            $(".swell-redemption-product-list").append('<li class="swell-redemption-product"> <div class="swell-redemption-product-content" data-redemption-option-id="' + option.id + '"> <div class="swell-redemption-product-image"> <img src="' + option.background_image_url + '" class="swell-product-image"> </div> <div class="swell-redemption-product-value">' + option.name + '</div> <div class="swell-redemption-product-cost">' + option.cost_text + '</div> <div class="variant-dropdown l_skimpy-dropdown"> </div>  <div class="l_skimpy-redeem">    <div class="swell-redemption-product-btn swell-buy-product-btn swell-buy-main-btn" data-variant-id="'+ option.applies_to_id + '">Redeem Now</div>  </div>  </div> </li>');
            $(".variant-dropdown.l_skimpy-dropdown").append('<select class="product-dropdown l_skimpy-select redemption-sizes" id="l_skimpy-select"> <option value="' + option.id +'">' + option_name +' </option> </select> ');
            l_skimpy += 1;
          } else {
            $(".l_skimpy-redeem").append('<div class="swell-redemption-product-btn swell-buy-product-btn" data-variant-id="' + option.applies_to_id +'">Redeem Now</div>');
            $(".l_skimpy-select").append('<option value="' + option.id +'">' + option_name +'</option>');
          }
        }

        else if(option.icon.indexOf("stephani") >= 0) {
          option_name = option.icon.split("-")[1]
          if(stephani == 0) {
            $(".swell-redemption-product-list").append('<li class="swell-redemption-product"> <div class="swell-redemption-product-content" data-redemption-option-id="' + option.id + '"> <div class="swell-redemption-product-image"> <img src="' + option.background_image_url + '" class="swell-product-image"> </div> <div class="swell-redemption-product-value">' + option.name + '</div> <div class="swell-redemption-product-cost">' + option.cost_text + '</div> <div class="variant-dropdown stephani-dropdown"> </div>  <div class="stephani-redeem">    <div class="swell-redemption-product-btn swell-buy-product-btn swell-buy-main-btn" data-variant-id="'+ option.applies_to_id + '">Redeem Now</div>  </div>  </div> </li>');
            $(".variant-dropdown.stephani-dropdown").append('<select class="product-dropdown stephani-select redemption-sizes" id="stephani-select"> <option value="' + option.id +'">' + option_name +' </option> </select> ');
            stephani += 1;
          } else {
            $(".stephani-redeem").append('<div class="swell-redemption-product-btn swell-buy-product-btn" data-variant-id="' + option.applies_to_id +'">Redeem Now</div>');
            $(".stephani-select").append('<option value="' + option.id +'">' + option_name +'</option>');
          }
        }

        else if(option.icon.indexOf("rib") >= 0) {
          option_name = option.icon.split("-")[1]
          if(rib == 0) {
            $(".swell-redemption-product-list").append('<li class="swell-redemption-product"> <div class="swell-redemption-product-content" data-redemption-option-id="' + option.id + '"> <div class="swell-redemption-product-image"> <img src="' + option.background_image_url + '" class="swell-product-image"> </div> <div class="swell-redemption-product-value">' + option.name + '</div> <div class="swell-redemption-product-cost">' + option.cost_text + '</div> <div class="variant-dropdown rib-dropdown"> </div>  <div class="rib-redeem">    <div class="swell-redemption-product-btn swell-buy-product-btn swell-buy-main-btn" data-variant-id="'+ option.applies_to_id + '">Redeem Now</div>  </div>  </div> </li>');
            $(".variant-dropdown.rib-dropdown").append('<select class="product-dropdown rib-select redemption-sizes" id="rib-select"> <option value="' + option.id +'">' + option_name +' </option> </select> ');
            rib += 1;
          } else {
            $(".rib-redeem").append('<div class="swell-redemption-product-btn swell-buy-product-btn" data-variant-id="' + option.applies_to_id +'">Redeem Now</div>');
            $(".rib-select").append('<option value="' + option.id +'">' + option_name +'</option>');
          }
        }

        else if(option.icon.indexOf("ri_skimpy") >= 0) {
          option_name = option.icon.split("-")[1]
          if(ri_skimpy == 0) {
            $(".swell-redemption-product-list").append('<li class="swell-redemption-product"> <div class="swell-redemption-product-content" data-redemption-option-id="' + option.id + '"> <div class="swell-redemption-product-image"> <img src="' + option.background_image_url + '" class="swell-product-image"> </div> <div class="swell-redemption-product-value">' + option.name + '</div> <div class="swell-redemption-product-cost">' + option.cost_text + '</div> <div class="variant-dropdown ri_skimpy-dropdown"> </div>  <div class="ri_skimpy-redeem">    <div class="swell-redemption-product-btn swell-buy-product-btn swell-buy-main-btn" data-variant-id="'+ option.applies_to_id + '">Redeem Now</div>  </div>  </div> </li>');
            $(".variant-dropdown.ri_skimpy-dropdown").append('<select class="product-dropdown ri_skimpy-select redemption-sizes" id="ri_skimpy-select"> <option value="' + option.id +'">' + option_name +' </option> </select> ');
            ri_skimpy += 1;
          } else {
            $(".ri_skimpy-redeem").append('<div class="swell-redemption-product-btn swell-buy-product-btn" data-variant-id="' + option.applies_to_id +'">Redeem Now</div>');
            $(".ri_skimpy-select").append('<option value="' + option.id +'">' + option_name +'</option>');
          }
        }

        else if(option.icon.indexOf("peyton") >= 0) {
          option_name = option.icon.split("-")[1]
          if(peyton == 0) {
            $(".swell-redemption-product-list").append('<li class="swell-redemption-product"> <div class="swell-redemption-product-content" data-redemption-option-id="' + option.id + '"> <div class="swell-redemption-product-image"> <img src="' + option.background_image_url + '" class="swell-product-image"> </div> <div class="swell-redemption-product-value">' + option.name + '</div> <div class="swell-redemption-product-cost">' + option.cost_text + '</div> <div class="variant-dropdown peyton-dropdown"> </div>  <div class="peyton-redeem">    <div class="swell-redemption-product-btn swell-buy-product-btn swell-buy-main-btn" data-variant-id="'+ option.applies_to_id + '">Redeem Now</div>  </div>  </div> </li>');
            $(".variant-dropdown.peyton-dropdown").append('<select class="product-dropdown peyton-select redemption-sizes" id="peyton-select"> <option value="' + option.id +'">' + option_name +' </option> </select> ');
            peyton += 1;
          } else {
            $(".peyton-redeem").append('<div class="swell-redemption-product-btn swell-buy-product-btn" data-variant-id="' + option.applies_to_id +'">Redeem Now</div>');
            $(".peyton-select").append('<option value="' + option.id +'">' + option_name +'</option>');
          }
        }

        else if(option.icon.indexOf("ri_tide") >= 0) {
          option_name = option.icon.split("-")[1]
          if(ri_tide == 0) {
            $(".swell-redemption-product-list").append('<li class="swell-redemption-product"> <div class="swell-redemption-product-content" data-redemption-option-id="' + option.id + '"> <div class="swell-redemption-product-image"> <img src="' + option.background_image_url + '" class="swell-product-image"> </div> <div class="swell-redemption-product-value">' + option.name + '</div> <div class="swell-redemption-product-cost">' + option.cost_text + '</div> <div class="variant-dropdown ri_tide-dropdown"> </div>  <div class="ri_tide-redeem">    <div class="swell-redemption-product-btn swell-buy-product-btn swell-buy-main-btn" data-variant-id="'+ option.applies_to_id + '">Redeem Now</div>  </div>  </div> </li>');
            $(".variant-dropdown.ri_tide-dropdown").append('<select class="product-dropdown ri_tide-select redemption-sizes" id="ri_tide-select"> <option value="' + option.id +'">' + option_name +' </option> </select> ');
            ri_tide += 1;
          } else {
            $(".ri_tide-redeem").append('<div class="swell-redemption-product-btn swell-buy-product-btn" data-variant-id="' + option.applies_to_id +'">Redeem Now</div>');
            $(".ri_tide-select").append('<option value="' + option.id +'">' + option_name +'</option>');
          }
        }

        else if(option.icon.indexOf("niko") >= 0) {
          option_name = option.icon.split("-")[1]
          if(niko == 0) {
            $(".swell-redemption-product-list").append('<li class="swell-redemption-product"> <div class="swell-redemption-product-content" data-redemption-option-id="' + option.id + '"> <div class="swell-redemption-product-image"> <img src="' + option.background_image_url + '" class="swell-product-image"> </div> <div class="swell-redemption-product-value">' + option.name + '</div> <div class="swell-redemption-product-cost">' + option.cost_text + '</div> <div class="variant-dropdown niko-dropdown"> </div>  <div class="niko-redeem">    <div class="swell-redemption-product-btn swell-buy-product-btn swell-buy-main-btn" data-variant-id="'+ option.applies_to_id + '">Redeem Now</div>  </div>  </div> </li>');
            $(".variant-dropdown.niko-dropdown").append('<select class="product-dropdown niko-select redemption-sizes" id="niko-select"> <option value="' + option.id +'">' + option_name +' </option> </select> ');
            niko += 1;
          } else {
            $(".niko-redeem").append('<div class="swell-redemption-product-btn swell-buy-product-btn" data-variant-id="' + option.applies_to_id +'">Redeem Now</div>');
            $(".niko-select").append('<option value="' + option.id +'">' + option_name +'</option>');
          }
        }

        else if(option.icon.indexOf("ri_knot") >= 0) {
          option_name = option.icon.split("-")[1]
          if(ri_knot == 0) {
            $(".swell-redemption-product-list").append('<li class="swell-redemption-product"> <div class="swell-redemption-product-content" data-redemption-option-id="' + option.id + '"> <div class="swell-redemption-product-image"> <img src="' + option.background_image_url + '" class="swell-product-image"> </div> <div class="swell-redemption-product-value">' + option.name + '</div> <div class="swell-redemption-product-cost">' + option.cost_text + '</div> <div class="variant-dropdown ri_knot-dropdown"> </div>  <div class="ri_knot-redeem">    <div class="swell-redemption-product-btn swell-buy-product-btn swell-buy-main-btn" data-variant-id="'+ option.applies_to_id + '">Redeem Now</div>  </div>  </div> </li>');
            $(".variant-dropdown.ri_knot-dropdown").append('<select class="product-dropdown ri_knot-select redemption-sizes" id="ri_knot-select"> <option value="' + option.id +'">' + option_name +' </option> </select> ');
            ri_knot += 1;
          } else {
            $(".ri_knot-redeem").append('<div class="swell-redemption-product-btn swell-buy-product-btn" data-variant-id="' + option.applies_to_id +'">Redeem Now</div>');
            $(".ri_knot-select").append('<option value="' + option.id +'">' + option_name +'</option>');
          }
        }
        
        else if(option.icon.indexOf("haydenb") >= 0) {
          option_name = option.icon.split("-")[1]
          if(haydenb == 0) {
            $(".swell-redemption-product-list").append('<li class="swell-redemption-product"> <div class="swell-redemption-product-content" data-redemption-option-id="' + option.id + '"> <div class="swell-redemption-product-image"> <img src="' + option.background_image_url + '" class="swell-product-image"> </div> <div class="swell-redemption-product-value">' + option.name + '</div> <div class="swell-redemption-product-cost">' + option.cost_text + '</div> <div class="variant-dropdown haydenb-dropdown"> </div>  <div class="haydenb-redeem">    <div class="swell-redemption-product-btn swell-buy-product-btn swell-buy-main-btn" data-variant-id="'+ option.applies_to_id + '">Redeem Now</div>  </div>  </div> </li>');
            $(".variant-dropdown.haydenb-dropdown").append('<select class="product-dropdown haydenb-select redemption-sizes" id="haydenb-select"> <option value="' + option.id +'">' + option_name +' </option> </select> ');
            haydenb += 1;
          } else {
            $(".haydenb-redeem").append('<div class="swell-redemption-product-btn swell-buy-product-btn" data-variant-id="' + option.applies_to_id +'">Redeem Now</div>');
            $(".haydenb-select").append('<option value="' + option.id +'">' + option_name +'</option>');
          }
        }
        
        else if(option.icon.indexOf("haydens") >= 0) {
          option_name = option.icon.split("-")[1]
          if(haydens == 0) {
            $(".swell-redemption-product-list").append('<li class="swell-redemption-product"> <div class="swell-redemption-product-content" data-redemption-option-id="' + option.id + '"> <div class="swell-redemption-product-image"> <img src="' + option.background_image_url + '" class="swell-product-image"> </div> <div class="swell-redemption-product-value">' + option.name + '</div> <div class="swell-redemption-product-cost">' + option.cost_text + '</div> <div class="variant-dropdown haydens-dropdown"> </div>  <div class="haydens-redeem">    <div class="swell-redemption-product-btn swell-buy-product-btn swell-buy-main-btn" data-variant-id="'+ option.applies_to_id + '">Redeem Now</div>  </div>  </div> </li>');
            $(".variant-dropdown.haydens-dropdown").append('<select class="product-dropdown haydens-select redemption-sizes" id="haydens-select"> <option value="' + option.id +'">' + option_name +' </option> </select> ');
            haydens += 1;
          } else {
            $(".haydens-redeem").append('<div class="swell-redemption-product-btn swell-buy-product-btn" data-variant-id="' + option.applies_to_id +'">Redeem Now</div>');
            $(".haydens-select").append('<option value="' + option.id +'">' + option_name +'</option>');
          }
        }
        
        else if(option.icon.indexOf("haydenh") >= 0) {
          option_name = option.icon.split("-")[1]
          if(haydenh == 0) {
            $(".swell-redemption-product-list").append('<li class="swell-redemption-product"> <div class="swell-redemption-product-content" data-redemption-option-id="' + option.id + '"> <div class="swell-redemption-product-image"> <img src="' + option.background_image_url + '" class="swell-product-image"> </div> <div class="swell-redemption-product-value">' + option.name + '</div> <div class="swell-redemption-product-cost">' + option.cost_text + '</div> <div class="variant-dropdown haydenh-dropdown"> </div>  <div class="haydenh-redeem">    <div class="swell-redemption-product-btn swell-buy-product-btn swell-buy-main-btn" data-variant-id="'+ option.applies_to_id + '">Redeem Now</div>  </div>  </div> </li>');
            $(".variant-dropdown.haydenh-dropdown").append('<select class="product-dropdown haydenh-select redemption-sizes" id="haydenh-select"> <option value="' + option.id +'">' + option_name +' </option> </select> ');
            haydenh += 1;
          } else {
            $(".haydenh-redeem").append('<div class="swell-redemption-product-btn swell-buy-product-btn" data-variant-id="' + option.applies_to_id +'">Redeem Now</div>');
            $(".haydenh-select").append('<option value="' + option.id +'">' + option_name +'</option>');
          }
        }

        else {
          $(".swell-redemption-product-list").append('<li class="swell-redemption-product"> <div class="swell-redemption-product-content" data-redemption-option-id="' + option.id + '"> <div class="swell-redemption-product-image"> <img src="' + option.background_image_url + '" class="swell-product-image"> </div> <div class="swell-redemption-product-value">' + option.name + '</div> <div class="swell-redemption-product-cost">' + option.cost_text + '</div> <div class="variant-dropdown"> </div>  <div class="">  <div class="swell-redemption-product-btn swell-buy-product-btn swell-buy-main-btn" data-variant-id="'+ option.applies_to_id + '">Redeem Now</div>  </div>  </div> </li>');
        }

      }
    });


    $(".product-dropdown").change(function (e) {
      value = e.target.value;
      redemptionOption = redemptionOption = swellAPI.findActiveRedemptionOptionById(value);
      element = redemptionOption.icon.split("-")[0]
      swellAPI.refreshEmbeds();
      $(".swell-buy-product-btn").not($("." + element + "-redeem .swell-buy-product-btn[data-variant-id="+ redemptionOption.applies_to_id +"]")).hide();
      $(".swell-buy-main-btn").show();
      $("." + element + "-redeem .swell-buy-product-btn").not($("." + element + "-redeem .swell-buy-product-btn[data-variant-id="+ redemptionOption.applies_to_id +"]")).hide();
      // $("." + element + "-redeem .swell-buy-product-btn[data-variant-id="+ redemptionOption.applies_to_id +"]").show();
    });


    swellAPI.refreshEmbeds();
    $(".swell-buy-product-btn").not($(".swell-buy-main-btn")).hide();
    // $(".swell-buy-main-btn").show();

    $(".swell-referral-loader").hide();
    image_path = "//www.beachbunnyswimwear.com/cdn/shop/t/106/assets/swell-referral-mobile.png?v=45812640800959895591670883798";
    image_path_desktop = "//www.beachbunnyswimwear.com/cdn/shop/t/106/assets/swell-referral.png?v=90847109844339319071670883798";
    $(".swell-campaign-list").prepend('<li class="swell-campaign refer-friend"> <div class="swell-campaign-content" data-display-mode="modal" data-campaign-id="<%= campaign.id %>"> <div class="swell-campaign-image"> <img class="swell-campaign-image-content swell-desktop" src="' + image_path_desktop +'" /> <img class="swell-campaign-image-content swell-mobile" src="' + image_path + '" /> <div class="swell-refer-friend"> <span class="refer-heading">re fer a friend</span> <h2 class="swell-referral-heading">Give $40, Get $40</h2> <a href="/pages/refer" class="swell-referral-referring">Start Referring now</a> </div> </div> </div> </li>');

    $( 'body' ).on('click',".register-btn", function() {
      $("#swell-referral-register-submit").click();
    });

    $( 'body' ).on('click',".refer-btn", function() {
      $("#swell-referral-refer-submit").click();
    });

    $('.swell-redemption-product-list').slick({
      centerMode: true,
      centerPadding: false,
      slidesToShow: 4,
      arrows: true,
      nextArrow: '<div class="arrows-holder right-arrow"><i class="swell-icon-right"></i></div>',
      prevArrow: '<div class="arrows-holder left-arrow"><i class="swell-icon-left"></i></div>',
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          },
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });

    $(".arrows-holder.right-arrow.slick-arrow").click();
    setTimeout(function() {
      $(".arrows-holder.right-arrow.slick-arrow").click();
    }, 500)

    setupReferrals();

    $( document ).on('click',"#swell-referral-register-submit", function() {
      setTimeout(function(){
        if(spapi.customer.referral_receipts) {
          setupReferrals();
          if(spapi.customer.email) {
            $(".swell-referral-content-main").addClass("refer-step");
          }
        } else {
          setTimeout(function(){
            setupReferrals();
            if(spapi.customer.email) {
              $(".swell-referral-content-main").addClass("refer-step");
            }
          },1000)
        }
      },1000)
    });

    $(document).on("swell:referral:success", function() {
      swellAPI.refreshCustomerDetails(function(){
        var customerDetails = swellAPI.getCustomerDetails();
        referrals = customerDetails.referrals;

        $(".redeem-holder").show();

        $(".swell-referral-table tbody").html("");

        referrals.forEach(function(referral) {
          status = null;

          if(referral.completedAt){ 
            status = "Purchased(" + spapi.activeReferralCampaign.reward_text + " earned)";
          } else {
            status = "Invited";
          }

          $(".swell-referral-table tbody").append('<tr> <td>' +  referral.email + '</td><td>' + status +'</td></tr>');
        });
      });
    });

    $(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) { 
      if(textStatus && textStatus === "EMAILS_ALREADY_PURCHASED"){
        $(".refer-customer-error").remove();
        $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Sorry! Looks like this person has already made a purchase. Try referring another friend.</p>');
        $("#swell-referral-refer-emails").addClass("error-border");
      }

      if(textStatus && textStatus === "Please enter a valid email address"){
        $(".refer-customer-error").remove();
        $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Please enter valid email addresses seperated with commas</p>');
        $("#swell-referral-refer-emails").addClass("error-border");
      }
    });

    $(".swell-tier-arrows .right-arrow").click(function() {
      var last = false;
      var length = $(".swell-tier-table thead tr:nth-child(1) th").length;

      for(counter = 2; counter <= length ; counter++) { 
        if (!$(".swell-tier-table thead tr th:nth-child(" + counter + ")").hasClass("hidden")) {
          if(counter == length) {
            last = true;
          }
          break;
        }
      }

      if(last == true) {
        $(".swell-tier-table  tr th:nth-child(" + counter + ")").addClass("hidden");
        $(".swell-tier-table  tr th:nth-child("+(counter - 3)+")").removeClass("hidden");

        $(".swell-tier-table  tr td:nth-child(" + counter + ")").addClass("hidden");
        $(".swell-tier-table  tr td:nth-child("+(counter - 3)+")").removeClass("hidden");
      } else {
        $(".swell-tier-table  tr th:nth-child(" + counter + ")").addClass("hidden");
        $(".swell-tier-table  tr th:nth-child("+(counter + 1)+")").removeClass("hidden");

        $(".swell-tier-table  tr td:nth-child(" + counter + ")").addClass("hidden");
        $(".swell-tier-table  tr td:nth-child("+(counter + 1)+")").removeClass("hidden");
      }        
    });

    $(".swell-tier-arrows .left-arrow").click(function() {
      var first = false;
      var length = $(".swell-tier-table thead tr:nth-child(1) th").length;

      for(counter = 2; counter <= length ; counter++) { 
        if (!$(".swell-tier-table thead tr th:nth-child(" + counter + ")").hasClass("hidden")) {
          if(counter == 3) {
            first = true;
          }
          break;
        }
      }

      if(first == true) {
        $(".swell-tier-table  tr th:nth-child(" + counter + ")").addClass("hidden");
        $(".swell-tier-table  tr th:nth-child("+(counter + 3)+")").removeClass("hidden");

        $(".swell-tier-table  tr td:nth-child(" + counter + ")").addClass("hidden");
        $(".swell-tier-table  tr td:nth-child("+(counter + 3)+")").removeClass("hidden");
      } else {
        $(".swell-tier-table thead tr th:nth-child(" + counter + ")").addClass("hidden");
        $(".swell-tier-table thead tr th:nth-child("+(counter - 1)+")").removeClass("hidden");

        $(".swell-tier-table tbody tr td:nth-child(" + counter + ")").addClass("hidden");
        $(".swell-tier-table tbody tr td:nth-child("+(counter - 1)+")").removeClass("hidden");
      }        
    });

  });
}).call(this);

function setupReferrals (){
  if(spapi.customer.email) {
    if(spapi.customer.referral_receipts.length > 0) {
      $(".redeem-holder").show();

      referrals = spapi.customer.referral_receipts;

      referrals.forEach(function(referral) {
        status = null;

        if(referral.completed_at){ 
          status = "Purchased(" + spapi.activeReferralCampaign.reward_text + " earned)";
        } else {
          status = "Invited";
        }

        $(".swell-referral-table tbody").append('<tr> <td>' +  referral.email + '</td><td>' + status +'</td></tr>');
      });  
    }
  }
}

// campaigns
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Campaign = {
    opts: {
      templates: {
        campaign: '<li class="swell-campaign"> <div class="swell-campaign-content" data-display-mode="modal" data-campaign-id="<%= campaign.id %>"> <div class="swell-campaign-image"> <img class="swell-campaign-image-content" src="<%= campaign.background_image_url %>" alt="<%= campaign.title %>"> <div class="swell-campaign-content-holder"> <div class="swell-campaign-icon"> <span class="swell-campaign-icon-content"><i class="fa <%= campaign.icon %>"> <span class="path1"> </span><span class="path2"></span></i></span> </div><div class="swell-campaign-type"> <span class="swell-campaign-type-content"><%= campaign.title %></span> </div> <div class="swell-campaign-value"> <span class="swell-campaign-value-content"><%= campaign.reward_text %></span> </div> </div> </div> </div> </li>',
        campaignHover: '<div class="swell-campaign-hover"> <div class="swell-campaign-hover-content"> <ul class="swell-link-list"> <li class="swell-link"> <a href="/account/register" class="swell-link-register">Sign Up</a> </li> <li class="swell-link"> -or- <a href="/account/login" class="swell-link-login">SIGN IN</a> </li> </ul> </div> </div>'
      }
    },
    authenticate: function() {
      if (!spapi.authenticated) {
        spapi.$(document).off("click", ".swell-campaign-content");
        $(".swell-campaign").addClass("swell-campaign-login");
        return $(".swell-campaign-content").hover(function() {
          return $(this).append(SwellConfig.Campaign.opts.templates.campaignHover);
        }, function() {
          return $(this).find(".swell-campaign-hover").remove();
        });
      }
    }
  };
}).call(this);

// history popup
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Customer = {
    initializeHistory: function(containerSelector) {
      return $(containerSelector).click(function() {
        return swellAPI.showPopupByType("HistoryPopup");
      });
    }
  };
}).call(this);

// faqs
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Faq = {
    initializeFaqs: function(containerSelector) {
      var collapsed_text, expanded_text;
      expanded_text = "Show Less <i class=\"fa fa-chevron-up\" aria-hidden=\"true\"></i>";
      collapsed_text = "Show All FAQs <i class=\"fa fa-chevron-down\" aria-hidden=\"true\"></i>";
      return $(containerSelector).click(function(e) {
        var $swell_question_list;
        if ($(e.target).is(containerSelector)) {
          $swell_question_list = $(".swell-question-list");
          $swell_question_list.toggleClass("swell-question-list-expanded");
          return $(".swell-question-button").html($swell_question_list.hasClass("swell-question-list-expanded") ? expanded_text : collapsed_text);
        }
      });
    }
  };
}).call(this);

// links
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Link = {
    initializeLinks: function(containerSelector) {
      return $(document).on("click", containerSelector, function(e) {
        var href;
        e.preventDefault();
        href = $(this).attr("href");
        localStorage.setItem("swell-location", "/pages/rewards");
        return window.location = href;
      });
    },
    initializeAnchor: function() {
      return setTimeout(function() {
        return $('html, body').animate({
          scrollTop: $(window.location.hash).offset().top,
          'slow': 'slow'
        });
      }, 1000);
    }
  };
}).call(this);

// local storage
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.LocalStorage = {
    initializeLocalStorage: function() {
      var location;
      location = localStorage.getItem("swell-location");
      if (location && window.location.pathname === '/account') {
        localStorage.removeItem("swell-location");
        return window.location = location;
      }
    }
  };
}).call(this);

// redemption
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Redemption = {
    opts: {
      templates: {
        redemptionoptionCoupon: "<li class=\"swell-redemption-option\">\n  <div\n    class=\"swell-redemption-option-content\"\n    data-redemption-option-id=\"<%= redemption.id %>\"\n    <% if (redemption.background_image_url) { %>\n      style=\"background-image:url(<%= redemption.background_image_url %>)\"\n    <% } %>\n    >\n <div class=\"swell-redemption-option-value\"><%= redemption.name %></div>\n    <div class=\"swell-redemption-option-cost\"><%= redemption.cost_text %></div>\n </div>\n</li>",
        redemptionOptionProduct: '<li class="swell-redemption-product"> <div class="swell-redemption-product-content"> <div class="swell-redemption-product-image"> <img src="<%= redemption.background_image_url %>" class="swell-product-image"> </div> <div class="swell-redemption-product-value"><%= redemption.name %></div> <div class="swell-redemption-product-cost"><%= redemption.cost_text %></div>                      <select class="redemption-sizes"> <option> hello </option> <option> hello </option> <option> hello </option> </select>  <div class="swell-redemption-product-btn swell-buy-product-btn" data-variant-id="<%=redemption.applies_to_id %>">Redeem Now</div>  <div class="swell-redemption-product-btn swell-buy-product-btn" data-variant-id="<%=redemption.applies_to_id %>">Redeem Now</div>                       <div class="swell-redemption-product-btn swell-buy-product-btn" data-variant-id="<%=redemption.applies_to_id %>">Redeem Now</div> </div> </li>'
      }
    }
  };
}).call(this);

// referral
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Referral = {
    opts: {
      localization: {
        referralSidebarDetailsAction: "Refer a Friend",
        referralSidebarDetailsReward: "<%= referralCampaign.reward_text %>",

        referralRegisterHeading: "<span class='refer-heading'> Refer a Friend </span> Give <%= referralCampaign.reward_text %>, Get <%= referralCampaign.reward_text %>",
        referralRegisterFormDetails: "Submit your email to get started.",
        referralRegisterFormEmail: "Your E-mail Address...",
        referralRegisterFormSubmit: "Next",
        referralRegisterDetails: "<%= referralCampaign.details %>",

        referralReferHeading: "<span class='refer-heading'> Refer a Friend </span> Give <%= referralCampaign.reward_text %>, Get <%= referralCampaign.reward_text %>",
        referralReferFormEmails: "Your friends’ emails (separated by commas)",
        referralReferFormSubmit: "Send",
        referralReferFormDetails: "Now, enter your friends’ emails.",
        referralReferFormEmailsDetails: "",
        referralReferDetails: "<%= referralCampaign.details %>",

        referralReferMediaDetails: "You can also share the link with the buttons below.",

        referralShareFacebook: "Share",
        referralShareTwitter: "Tweet",
        referralShareCopy: "Copy Link",
        referralShareMessenger: "Message",
        referralShareSMS: "SMS",

        referralFacebookIcon: "swell-icon-facebook-share",
        referralTwitterIcon: "swell-icon-tweet",
        referralLinkIcon: "swell-icon-copylink",
        referralMessengerIcon: "swell-icon-fb-message",
        referralSMSIcon: "swell-icon-sms",

        referralThanksHeading: "Thanks for Referring!",
        referralThanksDetails: "Remind your friends to check their emails.",

        referralCopyHeading: "Copy Link",
        referralCopyButton: "Copy Link",
        referralCopyDetails: "Copy link and share with your friends."
      },
      templates: {
        referralRegister: '<div class="swell-referral-register"> <h2 class="swell-referral-heading"><%= localization.referralRegisterHeading %></h2> <p class="swell-referral-details"> <%= localization.referralRegisterDetails %> </p> <div class="swell-referral-form-wrapper"> <form name="swell-referral-register-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"> <%= localization.referralRegisterFormDetails %> </p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="<%= localization.referralRegisterFormEmail %>"> </li> <li class="swell-referral-form-list-field"> <span class="swell-icon-arrow input-arrow register-btn"></span> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-register-submit" id="swell-referral-register-submit" value="<%= localization.referralRegisterFormSubmit %>"> </li> </ul> </div> </form> </div> </div>',
        referralRefer: '<div class="swell-referral-refer"> <h2 class="swell-referral-heading"><%= localization.referralReferHeading %></h2> <p class="swell-referral-details"> <%= localization.referralReferDetails %> </p> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"> <%= localization.referralReferFormDetails %> </p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="<%= localization.referralReferFormEmails %>"> </li> <li class="swell-referral-form-list-field"> <span class="swell-icon-right input-arrow refer-btn"></span> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value="<%= localization.referralReferFormSubmit %>"> </li> </ul> </div> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"> <%= localization.referralReferMediaDetails %> </p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralFacebookIcon %>" aria-hidden="true"></i>&nbsp; <%= localization.referralShareFacebook %> </div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralMessengerIcon %>" aria-hidden="true"></i><%= localization.referralShareMessenger %></div> </li> <li class="swell-referral-medium swell-share-referral-twitter"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralTwitterIcon %>" aria-hidden="true"></i><%= localization.referralShareTwitter %></div> </li> <li class="swell-referral-medium swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralSMSIcon %>" aria-hidden="true"></i><%= localization.referralShareSMS %></div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralLinkIcon %>" aria-hidden="true"></i>&nbsp; <%= localization.referralShareCopy %> </div> </li> </ul> </div> </div>',
        referralCopy: '<div class="swell-referral-copy"> <div class="swell-referral-copy-content"> <span class="swell-referral-back-link"></span> <div class="swell-referral-copy-sidebar"> <h2 class="swell-referral-heading"> <i class="swell-referral-heading-icon <%= localization.referralLinkIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralCopyHeading %> </h2> </div> <div class="swell-referral-copy-main"> <div class="swell-referral-form-wrapper"> <div class="swell-referral-copy-link" id="swell-referral-copy-link"> <%= customer.referralLink %> </div> <button class="swell-referral-copy-button" id="swell-referral-copy-button" data-clipboard-target="#swell-referral-copy-link"> <%= localization.referralCopyButton %> </button> <p class="swell-referral-details"> <%= localization.referralCopyDetails %> </p> </div> </div> </div> <div>'
      }
    },
    initializeReferral: function(containerSelector) {
      var email = $(containerSelector).data("customer-email");
      if (email) {
        spapi.storage.setItem("referrer_email", email);
        spapi.customer.email = email;
      }
      Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
    }
  };
}).call(this);

// tiers
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Tier = {
    getCustomerTierId: function() {
      var customer_tier, intro_tier, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier) {
        return customer_tier.id;
      } else {
        intro_tier = $.grep(tiers, function(e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].id;
        } else {
          return null;
        }
      }
    },
    getCustomerTierRank: function() {
      var customer_tier, intro_tier, rank, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier && customer_tier.id) {
        rank = $.grep(tiers, function(e) {
          return e.id === customer_tier.id;
        })[0].rank;
        return rank;
      } else {
        intro_tier = $.grep(tiers, function(e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].rank;
        } else {
          return null;
        }
      }
    },
    getTierByRank: function(rank) {
      var tiers;
      tiers = spapi.activeVipTiers;
      return $.grep(tiers, function(e) {
        return e.rank === rank;
      })[0];
    },
    setupCustomerTierStatus: function() {
      var $tierStatusRow, $tierValueRow, col, columnLength, customer_tier_id, customer_tier_rank, data_id, dollar_difference, encouragement, index, k, l, next_tier, ref, ref1;
      customer_tier_id = SwellConfig.Tier.getCustomerTierId();
      customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
      next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);
      $(".swell-tier-table").addClass("swell-tier-status");
      $(".swell-tier-table thead").prepend("<tr class=\"swell-tier-status-row\">\n  <th scope=\"row\"></th>\n</tr>");
      tiers = spapi.activeVipTiers;
      customer_tier = null;
      tiers.forEach(function(tier) {
        if(tier.id  == customer_tier_id) {
          customer_tier = tier;
        }
      });

      if (customer_tier == null) {
        $(".tier-name").html("Please spend $1 to be in Gold tier");
        $(".swell-tier-table thead .swell-tier-status-row").append('<th scope="col"> Spend $1 to be in Gold tier </th>');
                $(".swell-tier-table thead .swell-tier-status-row").append('<th scope="col"> </th> <th scope="col"> </th> <th scope="col"> </th>');
      } else {
        tiers.forEach(function(tier) {
          if(customer_tier != undefined && tier.rank < customer_tier.rank) {
            $(".swell-tier-table thead .swell-tier-status-row").append('<th scope="col"> </th>');
          } else if(customer_tier != undefined && tier.rank == customer_tier.rank) {
            $(".swell-tier-table thead .swell-tier-status-row").append('<th scope="col"> <span class="current-status">Current status <span class="arrow-down"></span></span> </th>');
            $(".tier-name").html(customer_tier.name);
          } else if (next_tier && tier.rank == next_tier.rank) {
            if(spapi.customer.vip_tier_stats) {
              tier_difference = (tier.amount_spent_cents - spapi.customer.vip_tier_stats.amount_spent_cents)/100;
            } else {
              tier_difference = (tier.amount_spent_cents - 0)/100;
            }
            $(".swell-tier-table thead .swell-tier-status-row").append('<th scope="col"><span class="next-status">Spend $' + tier_difference + ' more for ' + tier.name + '</span></th>');
          } else {
            $(".swell-tier-table thead .swell-tier-status-row").append('<th scope="col"> </th>');
          }
        });
      }

      if (spapi.isMobile) {
        SwellConfig.Tier.tierTableOnMobile(customer_tier_rank + 2);
      }
    },
    tierTableOnMobile: function(current) {
      var columnLength = $(".swell-tier-table .swell-tier-values").children().length;
      for(counter = 2;counter<=columnLength;counter++) {
        if(counter!=current) {
          $(".swell-tier-table tr th:nth-child(" + counter + ")").addClass("hidden");
          $(".swell-tier-table tr td:nth-child(" + counter + ")").addClass("hidden");
        }      
      }
    },
    // initializeDummyTier: function() {
    //   var k, len, tier, tiers;
    //   tiers = spapi.activeVipTiers;
    //   for (k = 0, len = tiers.length; k < len; k++) {
    //     tier = tiers[k];
    //     tier.rank += 1;
    //   }
    //   return tiers.unshift({
    //     id: -1,
    //     rank: 0,
    //     name: "(Re)sister",
    //     points: "$0&ndash;$199",
    //     one_point_multiplier: "<div class='circle'></div>",
    //     free_shipping: "<div class='circle'></div>",
    //     new_arrivals: "",
    //     season_offers: "",
    //     bunny_beach_towel: "",
    //     swellrequiredAmountSpent: "$0",
    //     swellrequiredAmountSpentCents: 0,
    //     swellrequiredPointsEarned: 0,
    //     swellrequiredPurchasesMade: 0,
    //     swellrequiredReferralsCompleted: 0
    //   });
    // },
    initializeCustomTierProperties: function() {
      spapi.activeVipTiers[0].points = "$1&ndash;$599";
      spapi.activeVipTiers[0].one_point_multiplier = "1x";
      spapi.activeVipTiers[0].free_shipping = "Free Standard Over $250";
      spapi.activeVipTiers[0].new_arrivals = "";
      spapi.activeVipTiers[0].season_offers = "";
      spapi.activeVipTiers[0].bunny_beach_towel = "";
      spapi.activeVipTiers[0].hat = "";
      spapi.activeVipTiers[0].giveaways = "";
      spapi.activeVipTiers[0].events = "";
      spapi.activeVipTiers[0].towel = "";
      spapi.activeVipTiers[0].vip_box = "";

      spapi.activeVipTiers[1].points = "$600&ndash;$1499";
      spapi.activeVipTiers[1].one_point_multiplier = "1.5x";
      spapi.activeVipTiers[1].free_shipping = "Free 3 Day Over $350";
      spapi.activeVipTiers[1].new_arrivals = "<div class='circle'></div>";
      spapi.activeVipTiers[1].season_offers = "<div class='circle'></div>";
      spapi.activeVipTiers[1].bunny_beach_towel = "<div class='circle'></div>";
      spapi.activeVipTiers[1].hat = "<div class='circle'></div>";
      spapi.activeVipTiers[1].giveaways = "";
      spapi.activeVipTiers[1].events = "";
      spapi.activeVipTiers[1].towel = "";
      spapi.activeVipTiers[1].vip_box = "";

      spapi.activeVipTiers[2].points = "$1500+";
      spapi.activeVipTiers[2].one_point_multiplier = "2x";
      spapi.activeVipTiers[2].free_shipping = "Free 2 Day Over $450";
      spapi.activeVipTiers[2].new_arrivals = "<div class='circle'></div>";
      spapi.activeVipTiers[2].season_offers = "<div class='circle'></div>";
      spapi.activeVipTiers[2].bunny_beach_towel = "<div class='circle'></div>";
      spapi.activeVipTiers[2].hat = "<div class='circle'></div>";
      spapi.activeVipTiers[2].giveaways = "<div class='circle'></div>";
      spapi.activeVipTiers[2].events = "";
      spapi.activeVipTiers[2].towel = "<div class='circle'></div>";
      spapi.activeVipTiers[2].vip_box = "";

      spapi.activeVipTiers[3].points = "$6000+";
      spapi.activeVipTiers[3].one_point_multiplier = "2x";
      spapi.activeVipTiers[3].free_shipping = "Free Overnight Over $600";
      spapi.activeVipTiers[3].new_arrivals = "<div class='circle'></div>";
      spapi.activeVipTiers[3].season_offers = "<div class='circle'></div>";
      spapi.activeVipTiers[3].bunny_beach_towel = "<div class='circle'></div>";
      spapi.activeVipTiers[3].bunny_beach_towel = "<div class='circle'></div>";
      spapi.activeVipTiers[3].hat = "<div class='circle'></div>";
      spapi.activeVipTiers[3].giveaways = "<div class='circle'></div>";
      spapi.activeVipTiers[3].events = "<div class='circle'></div>";
      spapi.activeVipTiers[3].towel = "<div class='circle'></div>";
      spapi.activeVipTiers[3].vip_box = "<div class='circle'></div>";
    },
    initializeTiers: function(containerSelector) {
      var i, j, key, properties, property, ref, ref1, tiers;
      if ($(containerSelector).length === 0) {
        return "";
      }
      tiers = spapi.activeVipTiers;
      properties = {
        header: {
          name: {
            className: "swell-tier-names",
            title: "Rewards"
          },
          points: {
            className: "swell-tier-values",
            title: ""
          }
        },
        body: {
          one_point_multiplier: {
            title: "Point Multiplier"
          },
          free_shipping: {
            title: "Shipping Benefit"
          },
          new_arrivals: {
            title: "Early access to new arrivals"
          },
          season_offers: {
            title: "Exclusive in-season offers"
          },
          giveaways: {
            title: "Annual Birthday Gift"
          },
          events: {
            title: "Limited Edition product access"
          },
          vip_box: {
            title: "VIP box"
          }
        }
      };
      $(containerSelector).append("<thead></thead>");
      $(containerSelector).append("<tbody></tbody>");
      j = 0;
      ref = properties.header;
      for (key in ref) {
        property = ref[key];
        $(containerSelector).find("thead").append("<tr class=\"" + property.className + "\">\n  <th scope=\"row\" rowspan='2'>" + property.title + "</th>\n</tr>");
        tiers.forEach(function(tier) {
          return $(containerSelector).find("thead tr:eq(" + j + ")").append("<th scope=\"col\" data-tier-id=\"" + tier.id + "\">" + tier[key] + "</th>");
        });
        j++;
      }
      i = 0;
      ref1 = properties.body;
      for (key in ref1) {
        property = ref1[key];
        $(containerSelector).find("tbody").append("<tr>\n  <th scope=\"row\">" + property.title + "</th>\n</tr>");
        tiers.forEach(function(tier) {
          return $(containerSelector).find("tbody tr:eq(" + i + ")").append("<td data-tier-id=\"" + tier.id + "\">" + tier[key] + "</td>");
        });
        i++;
      }
      if (spapi.authenticated) {
        SwellConfig.Tier.setupCustomerTierStatus();
      } else if (spapi.isMobile){
        SwellConfig.Tier.tierTableOnMobile(2);
      }

      $(window).resize(function(){
        if($(document).width() < 758) {
          if(spapi.authenticated) {
            SwellConfig.Tier.tierTableOnMobile(customer_tier_rank + 2);
          } else {
            SwellConfig.Tier.tierTableOnMobile(2);
          }

        } else {
          $(".swell-tier-table  tr th").removeClass("hidden");
          $(".swell-tier-table  tr td").removeClass("hidden");
        }
      });
    }
  };
}).call(this);


// faqs initializer
(function() {
  var classNames, selectors,
      indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  classNames = {
    container: "swell-question-content",
    heading: "swell-question-heading",
    section: "swell-question-details",
    open: "swell-question-open"
  };

  selectors = {
    container: "." + classNames.container,
    heading: "." + classNames.heading,
    section: "." + classNames.section,
    open: "." + classNames.open
  };

  $(document).ready(function() {
    var hash, heading, openCollapsiblesForAnchor, toHide;
    openCollapsiblesForAnchor = function(hash, redirect) {
      var anchors, el, name;
      name = hash.substr(1);
      anchors = $(selectors.container).find(hash + ", a[name=\"" + name + "\"]");
      if (anchors.length > 0) {
        el = $(anchors[0]);
        el.closest(selectors.container).find(selectors.heading).click();
        return el.closest(selectors.section).promise().done(function() {
          return window.location = redirect;
        });
      } else if ($(hash).is(selectors.container)) {
        return $(hash).find(selectors.heading).click();
      }
    };
    $(selectors.container).css("overflow", "hidden");
    toHide = $(selectors.container).not(selectors.open).find(selectors.section);
    heading = $(selectors.heading);
    toHide.hide();
    heading.css("cursor", "pointer");
    heading.click(function() {
      var parent, t;
      t = $(this);
      parent = t.parent();
      if (parent.hasClass(classNames.open)) {
        parent.removeClass(classNames.open);
        t.attr("aria-expanded", "false");
      } else {
        parent.addClass(classNames.open);
        t.attr("aria-expanded", "true");
      }
      t.next().slideToggle("fast");
      return false;
    });
    $(document).keydown(function(e) {
      if ((32 === e.keyCode || 13 === e.keyCode) && $(e.target).hasClass(classNames.heading)) {
        e.preventDefault();
        e.target.click();
        return false;
      }
    });
    if (window.location.hash) {
      hash = window.location.hash;
      openCollapsiblesForAnchor(hash, window.location);
    }
    if (indexOf.call(window, "onhashchange") >= 0) {
      return $(window).bind("hashchange", function(e) {
        hash = window.location.hash;
        return openCollapsiblesForAnchor(hash, window.location);
      });
    }
  });
}).call(this);
